import {ListEmailCredentialsResponseBody} from '@dms/api/core';
import i18n from '@dms/i18n';

type Mailbox = ListEmailCredentialsResponseBody['credentials'][number];

const mailboxToOption = (mailbox: Mailbox) => ({
  label: `${mailbox.title} (${mailbox.emailAddress})`,
  value: mailbox.id,
});

/**
 * Groups connected mailboxes into choice option groups: the user's own mailboxes first,
 * then the tenant-wide ones.
 */
export const getMailboxOptionsByOwner = (mailboxes: Mailbox[]) => [
  {
    label: i18n.t('general.labels.user'),
    options: mailboxes.filter((mailbox) => mailbox.ownerType === 'user').map(mailboxToOption),
  },
  {
    label: i18n.t('page.homepage.labels.tenant'),
    options: mailboxes.filter((mailbox) => mailbox.ownerType === 'tenant').map(mailboxToOption),
  },
];
